/**
 * Video Cover Block - Save Component
 *
 * Saves only InnerBlocks content. The outer wrapper is rendered server-side
 * via render.php with Interactivity API directives.
 *
 * @package BrandyBlocks
 */

import { InnerBlocks } from "@wordpress/block-editor";

export default function Save() {
  return <InnerBlocks.Content />;
}
